import { useEffect } from 'react'

// parameters:
// - selectors: array of selectors to attach event handlers to
// - filterFn: function to filter out elements that should not have event handlers attached
export default function useAttachPageEventHandlers ({
  selectors,
  filterFn,
  event,
  eventHandler,
}) {
  const selectorsString = selectors.join(', ')

  useEffect(() => {
    const elements = document.querySelectorAll(selectorsString)
    const filteredElements = filterFn
      ? Array.from(elements).filter(filterFn)
      : elements

    filteredElements.forEach((element) => {
      element.addEventListener(event, eventHandler)
    })
  }, [])
}
